import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './i18n'
import { initializeTelegram, getTelegramWebApp } from './utils/telegram'
import AppErrorBoundary from './components/AppErrorBoundary'
import { mark, observeImages } from './utils/performance'

async function startApp() {
  await window.PolkaBootstrap?.telegramReady;
  if (window.PolkaBootstrap?.telegramLaunch && !getTelegramWebApp()?.initData) {
    throw new Error('Telegram launch data unavailable');
  }
  initializeTelegram();
  mark('polka:react-start');
  observeImages();

  // Регистрация Service Worker при старте
  if (!getTelegramWebApp() && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' })
    .then(registration => {
      console.log('SW зарегистрирован:', registration.scope);
    })
    .catch(error => {
      console.warn('SW регистрация не удалась:', error.message);
    });
  }

  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <AppErrorBoundary><App /></AppErrorBoundary>
    </StrictMode>,
  );
  if (window.PolkaBootstrap) window.PolkaBootstrap.mounted = true;
}

startApp().catch(() => {
  window.PolkaBootstrap?.showError('Не удалось открыть приложение. Проверьте соединение и обновите страницу.');
});
